import { getColor } from 'common/constants/_colors';
import StackedAreaChart from 'components/StackedAreaChart';
import { METRICS_GOALS, METRICS_METADATA } from '../consts';
import { getXAxisLabel } from '../custom-report.serivce';
import {
  formatAnnotationsToPlotLines,
  getStackedGraphSettings,
  mapMetricsToAnnotationSeries
} from '../goals.service';
import {
  getToolTipTitleByDateRange,
  toolTipFormatter,
  getTooltipLegendData
} from '../Tooltip';
import _ from 'lodash';

const CustomReportStackedAreaChart = ({
  searchRange,
  granularity,
  metrics,
  graphId,
  annotations,
  axisTitle,
  unitDescription,
  isClickable,
  getEndDateForTooltip,
  workingDaysSetting
}) => {
  const {
    stackedSeries,
    metricsSettingName,
    graphMaxPoint,
    tickInterval,
    tickAmount
  } = getStackedGraphSettings({
    metricsConfig: METRICS_METADATA[graphId],
    metrics: metrics
      .map(item => item.data)
      .flat()
      .filter(Boolean)
  });

  const annotationMarkers = mapMetricsToAnnotationSeries({
    graphId,
    granularity,
    series: stackedSeries,
    maxPoint: graphMaxPoint,
    metricsSettingName,
    annotations
  });

  const annotationLines = formatAnnotationsToPlotLines(annotationMarkers);
  const isAnnotationsEmpty = _.isEmpty(annotationMarkers);

  const stackedChartData = {
    chart: {
      type: 'column',
      backgroundColor: null
    },
    xAxis: {
      gridLineColor: getColor('catskillGray'),
      categories: searchRange,
      labels: {
        formatter() {
          const displayEndDate = getEndDateForTooltip(this.value.before);
          return getXAxisLabel(
            displayEndDate,
            this.value.before,
            granularity,
            this.value.name,
            workingDaysSetting
          );
        }
      },
      plotLines: annotationLines
    },
    yAxis: {
      max: graphMaxPoint,
      tickAmount,
      tickInterval,
      gridLineColor: getColor('botticelli'),
      title: {
        text: axisTitle,
        align: 'low'
      }
    },
    tooltip: {
      outside: true
    },
    plotOptions: {
      series: {
        animation: false,
        stickyTracking: false
      },
      column: {
        maxPointWidth: 20,
        stacking: 'normal',
        tooltip: {
          snap: 1,
          headerFormat: undefined,
          pointFormatter() {
            const { legend, percent } = getTooltipLegendData(
              this,
              this.series,
              METRICS_GOALS.MET_GOALS.text
            );
            const displayEndDate = getEndDateForTooltip(this.category.before);

            return toolTipFormatter({
              title: getToolTipTitleByDateRange(
                this.category.after,
                displayEndDate,
                granularity,
                this.category.name
              ),
              percent,
              percentDescription: unitDescription,
              legend,
              isClickable
            });
          }
        }
      }
    },
    series: isAnnotationsEmpty
      ? stackedSeries
      : stackedSeries.concat(annotationMarkers)
  };

  return (
    <StackedAreaChart chartOptionsProp={stackedChartData} showLegend={false} />
  );
};

export default CustomReportStackedAreaChart;
